const english = require('../languages/english');
const hindi = require('../languages/hindi');
const marathi = require('../languages/marathi');
const bengali = require('../languages/bengali');
const german = require('../languages/german');
const arabic = require('../languages/arabic');

const Languages = {
    english: { keywords: english, defaultName: 'john' },
    hindi: { keywords: hindi, defaultName: 'रोहित' },
    marathi: { keywords: marathi, defaultName: 'सचिन' },
    bengali: { keywords: bengali, defaultName: '' },
    german: { keywords: german, defaultName: 'ludwig' },
    arabic: { keywords: arabic, defaultName: 'باسم' }
};

function getLanguage(langName) {
    return Languages[langName ? langName.toLowerCase() : 'english'] || Languages.english;
}

function getResolvedKeywords(langName, name, customKeywords = {}) {
    const lang = getLanguage(langName);
    const userName = name !== undefined ? name : lang.defaultName;
    const baseKeywords = { ...lang.keywords, ...customKeywords };

    const resolved = {};
    for (const [key, value] of Object.entries(baseKeywords)) {
        if (typeof value === 'string') {
            resolved[key] = value.replace(/{{name}}/g, userName);
        } else {
            resolved[key] = value;
        }
    }
    return resolved;
}

module.exports = { getLanguage, getResolvedKeywords, Languages };
